/**
 * Stop event immediate propagation.
 * @param {Event} event
 */
export function stopImmediatePropagation(event) {
  event.stopImmediatePropagation();
}
